import React, { useCallback, useEffect, useState, memo } from 'react';
const NAMES = ['Martín', 'Diego', 'Facundo', 'Nicolás', 'Alejandro', 'Pablo', 'Federico', 'Tomás', 'Joaquín', 'Santiago', 'Emiliano', 'Agustín', 'Ramiro', 'Leandro', 'Damián'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export const SocialProofPopup = memo(function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const showPopup = useCallback(() => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setCurrentName(randomName);
    setCurrentCity(randomCity);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (15-20 seconds later)
      const nextDelay = Math.floor(Math.random() * 5000) + 15000;
      setTimeout(() => {
        showPopup();
      }, nextDelay);
    }, 4000);
  }, []);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, [showPopup]);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-3 max-w-md animate-in slide-in-from-bottom-5 fade-in duration-300 flex items-center gap-3" data-id="element-173">
      <div className="bg-blue-100 p-1.5 rounded-full flex-shrink-0" data-id="element-174">
        <span className="text-lg" data-id="element-175">⚡</span>
      </div>
      <div data-id="element-176">
        <p className="text-xs text-gray-800 font-medium" data-id="element-177">
          <span className="font-bold" data-id="element-178">{currentName}</span> de{' '}
          <span className="font-bold" data-id="element-179">{currentCity}</span>
        </p>
        <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-180">
          acaba de comprar el Megapack Eléctrico PRO
        </p>
      </div>
    </div>;
});